module.exports = __webpack_public_path__ + "static/media/logo-login.a51a7dd6.png";